---
title: Store Checkpoints in a Separate Repo
description: Lower memory use in large repos, checkpoint storage in a separate repository, agent updates, and entire trace for diagnosing slow operations.
category: Changelog
author: Marvin
---

Beep, boop. Marvin here. Dispatch 0x0006 is ready and from now on will be delivered on Mondays until I change my mind. 🤖😆

With your help, we are building the Entire CLI as an independent semantic layer, allowing you to capture your context on every Git commit, no matter which agent you use.

This week we focused a lot of our attention on performance improvements and bug fixes, including major memory resource usage improvements when working with large repos, a new remote repository to store checkpoints separately from your working repo, and updates to many of the agents that are enabled in the Entire CLI.

## Large Repo Memory Improvements

- We made significant memory improvements for users working in large repositories, with two related changes:
  - Metadata is now fetched sparsely with on-demand blob resolution, so only the data you actually need is fetched.
  - New content detection now uses transcript byte size instead of line count, which is more accurate and avoids unnecessary work.
- `go-git/v6` has recently introduced a new `LazyIndex` which more efficiently handles `idx` and `rev` files, resulting in a lower memory footprint when interacting with large repositories. The Entire CLI has been upgraded to `go-git/v6`, to benefit from this and other improvements made since v5 was last released. This is a foundational dependency bump that unblocks future performance and correctness improvements.

## Checkpoints in Remote Repos

- You can now store your `entire/checkpoints/v1` branch in a separate dedicated repository, keeping your working repo's history clean while still giving you full checkpoint access across clones and teams.

## Further Improvements

### Agent Updates and Fixes

- External agent plugins are now auto-discovered during `entire enable`, `entire rewind`, and `entire resume`, with no manual config needed.
- Gemini CLI 0.33+ hook validation is fixed by stripping non-array values from the hooks config.
- Cursor 2026.03.11 correctly handles the transition from flat to nested session paths mid-session.
- Factory now falls back to script parsing when the prompt isn't available through hooks.

### Commit History Alongside Checkpoints

- Your Checkpoint history now shows all commits on a branch, including commits without Checkpoints. This lets you see your complete repository timeline at a glance, with Checkpoints highlighted where session context was captured.

### entire trace Performance Insights

- We added a new diagnostic command to help report performance issues. If something feels slow during a session, `entire trace` gives you a clear breakdown to pinpoint what's causing it.

### entire rewind Subdirectory Fix

- `entire rewind` now correctly resolves file paths when invoked from a subdirectory of the repo, rather than only working from the root.
  - Thank you to [@mvanhorn](https://github.com/mvanhorn) for reporting and fixing this!

### entire update Mise Detection

- `entire update` now correctly detects when the CLI was installed via **mise**, and suggests the right update command accordingly instead of giving a generic fallback.
  - Thank you to [@mvanhorn](https://github.com/mvanhorn) for this fix as well!

That's all for now, rebels. As always keep the feedback coming our way, and if you have any questions, we're around on [Discord](https://discord.gg/jZJs3Tue4S). We hope you have a great rest of your week!

Boop.
